import { render, staticRenderFns } from "./gallery-card-mc-gregor.vue?vue&type=template&id=d1ff592a&scoped=true&"
import script from "./gallery-card-mc-gregor.vue?vue&type=script&lang=js&"
export * from "./gallery-card-mc-gregor.vue?vue&type=script&lang=js&"
import style0 from "./gallery-card-mc-gregor.vue?vue&type=style&index=0&id=d1ff592a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff592a",
  null
  
)

export default component.exports